var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import { Component } from 'react';
import Button from 'react-toolbox/lib/button/Button';
import { Spinner } from './spinner';
export var LoadingButton = function (_Component) {
    _inherits(LoadingButton, _Component);

    function LoadingButton() {
        _classCallCheck(this, LoadingButton);

        var _this = _possibleConstructorReturn(this, (LoadingButton.__proto__ || Object.getPrototypeOf(LoadingButton)).apply(this, arguments));

        _this.state = {};
        _this.unmounted = false;
        return _this;
    }

    _createClass(LoadingButton, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.unmounted = true;
        }
    }, {
        key: 'setNotLoading',
        value: function setNotLoading() {
            if (!this.unmounted) {
                this.setState({ loading: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var internalLoading = this.state.loading;
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                onClick = _props.onClick,
                _props$loading = _props.loading,
                loading = _props$loading === undefined ? internalLoading : _props$loading;

            var buttonProps = Object.assign({}, this.props);
            delete buttonProps.loading;
            return React.createElement(Button, Object.assign({}, buttonProps, { disabled: disabled || loading, onClick: onClick && function (e) {
                    var returnValue = onClick(e);
                    if (returnValue) {
                        _this2.setState({ loading: true });
                        returnValue.then(function () {
                            return _this2.setNotLoading();
                        }).catch(function (error) {
                            _this2.setNotLoading();
                            throw error;
                        });
                    }
                } }), children, loading && React.createElement(Spinner, { size: 24, center: true, type: 'circular', background: 'rgba(255, 255, 255, 0.5)' }));
        }
    }]);

    return LoadingButton;
}(Component);
//# sourceMappingURL=loading-button.js.map
